<template>
  <div
    id="dev-AvailabilityCard"
    class="availability-card"
  >
    <div class="stat-item">
      <div :class="['availability-indicator', { available: hasBatteries }]"></div>
      <span class="stat-value">{{ availableBatteries }}</span>
      <span class="stat-label">{{ $t('map_navigation.available_batteries') }}</span>
      <span
        v-if="isLowBattery"
        class="low-battery-warning"
      >{{ $t('map_navigation.low_stock') }}</span>
    </div>
    <div class="stat-item">
      <div :class="['availability-indicator', { available: hasSlots }]"></div>
      <span class="stat-value">{{ availableSlots }}</span>
      <span class="stat-label">{{ $t('map_navigation.available_slots_return') }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AvailabilityCard',
    props: {
      availableBatteries: {
        type: [Number, String],
        default: 0
      },
      availableSlots: {
        type: [Number, String],
        default: 0
      }
    },
    computed: {
      hasBatteries() {
        return parseInt(this.availableBatteries) > 0
      },
      hasSlots() {
        return parseInt(this.availableSlots) > 0
      },
      isLowBattery() {
        return parseInt(this.availableBatteries) < 3
      }
    }
  }
</script>

<style scoped lang="scss">
  .availability-card {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 12px;
    position: relative;
  }

  .availability-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #dc3545;
    margin-bottom: 8px;
    box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
    animation: pulse-unavailable 2s infinite;

    &.available {
      background: #28a745;
      box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
      animation: pulse-available 2s infinite;
    }
  }

  @keyframes pulse-available {
    0% {
      box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
    }
    50% {
      box-shadow: 0 0 8px rgba(40, 167, 69, 0.6);
    }
    100% {
      box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
    }
  }

  @keyframes pulse-unavailable {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }

  .stat-value {
    font-size: 24px;
    font-weight: bold;
    color: #424242;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 12px;
    color: #666;
    text-align: center;
  }

  .low-battery-warning {
    font-size: 11px;
    color: #ff9800;
    font-weight: 600;
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  @media (max-width: 768px) {
    .availability-card {
      gap: 12px;
    }

    .stat-item {
      padding: 12px;
    }
  }

  @media (max-width: 480px) {
    .availability-card {
      gap: 10px;
    }

    .stat-item {
      padding: 12px;
    }

    .stat-value {
      font-size: 20px;
    }

    .stat-label {
      font-size: 11px;
    }
  }
</style>
